import React from 'react';
import { useMeasure } from 'react-use';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { BucketData } from '../../useAssetBucketingResults';
import { Bucket } from '../Bucket/Bucket';
import { RemoveAssetFn } from '../../../AssetBucketingEdit/AssetBucketingEdit.meta';

interface Props {
  buckets: BucketData[];
  isEditable?: boolean;
  onRemoveAsset?: RemoveAssetFn;
}

export const Buckets = ({ buckets, isEditable, onRemoveAsset }: Props) => {
  const [descriptionRef, { height: descriptionHeight }] = useMeasure<HTMLDivElement>();

  const largerDescriptionIndex = buckets.reduce((acc, { description }, index) => {
    return description.length > buckets[acc].description.length ? index : acc;
  }, 0);

  return (
    <Box as="section" display="flex" css="gap: 24px">
      {buckets.map((bucket, index) => (
        <Box key={bucket.id || bucket.title} as="article" flex={1}>
          <Bucket
            {...bucket}
            isEditable={isEditable}
            bucketIndex={index}
            onRemoveAsset={onRemoveAsset}
            descriptionElement={{
              ref: largerDescriptionIndex === index ? descriptionRef : undefined,
              height: descriptionHeight,
            }}
          />
        </Box>
      ))}
    </Box>
  );
};
